

export default [
  {
    url: '/dashboard/analytics',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    permission: 'public'
  },
  {
    url: null,
    name: 'calendar',
    slug: 'calendar',
    icon: 'CalendarIcon',
    i18n: 'Calendar',
    submenu: [
      {
        url: '/calendar',
        name: 'calendar',
        slug: 'calendar',
        i18n: 'Calendar',
        permission: 'calendar.event.list'
      },
      {
        url: '/calendar/events',
        name: 'calendar-events',
        slug: 'calendar-events',
        i18n: 'Event List',
        permission: 'calendar.event.list'
      }
    ]
  },
  // {
  //   url: '/calendar',
  //   name: 'calendar',
  //   slug: 'calendar',
  //   icon: 'CalendarIcon',
  //   tagColor: 'success',
  //   i18n: 'Calendar',
  //   permission: 'calendar.event.list'
  // },
  {
    url: '/task/list',
    name: 'tasks',
    slug: 'tasks',
    icon: 'ListIcon',
    i18n: 'Tasks',
    permission: 'task.list'
  },
  // {
  //   url: null,
  //   name: 'tasks',
  //   slug: 'tasks',
  //   icon: 'ListIcon',
  //   i18n: 'Tasks',
  //   submenu: [
  //     {
  //       url: '/task/list',
  //       name: 'task-list',
  //       slug: 'task-list',
  //       i18n: 'Task list'
  //     },
  //     {
  //       url: '/task',
  //       name: 'task-add',
  //       slug: 'task-add',
  //       i18n: 'New task'
  //     }
  //   ]
  // },
  {
    url: null,
    name: 'contacts',
    slug: 'contacts',
    icon: 'UsersIcon',
    i18n: 'Contacts',
    submenu: [
      {
        url: '/contacts',
        name: 'contacts-list',
        slug: 'contacts-list',
        i18n: 'Contact List',
        permission: 'contact.list'
      },
      {
        url: '/contacts/add',
        name: 'contacts-add',
        slug: 'contacts-add',
        i18n: 'New Contact',
        permission: 'contact.create'
      }
    ]
  },
  {
    url: null,
    name: 'Matters',
    slug: 'Matters',
    icon: 'BriefcaseIcon',
    i18n: 'Matters',
    submenu:[
      {
        url: '/matters',
        name: 'matters-list',
        slug: 'matters-list',
        i18n: 'Matter List',
        permission: 'matter.list'
      },
      {
        url: '/matters/add',
        name: 'contacts-add',
        slug: 'contacts-add',
        i18n: 'New Matter',
        permission: 'matter.create'
      }
    ]
  },
  {
    url: null,
    name: 'Notes',
    slug: 'Notes',
    icon: 'Edit2Icon',
    i18n: 'Notes',
    submenu:[
      {
        url: '/notes',
        name: 'notes-list',
        slug: 'notes-list',
        i18n: 'Notes List',
        permission: 'note.list'
      },
      {
        url: '/notes/add',
        name: 'notes-add',
        slug: 'notes-add',
        i18n: 'New Note',
        permission: 'note.create'
      }
    ]
  },
  {
    url: '/activities',
    name: "Activities",
    slug: "Activities",
    icon: 'ClockIcon',
    i18n: "Activities",
    permission: ['activity.time-entry.list','activity.expense-entry.list','activity.expense-entry.category.list']
  },
  {
    url: '/documents',
    name: 'document',
    slug: 'document',
    icon: 'FileIcon',
    i18n: 'Documents',
    permission: 'document.list'
  },
  {
    url: '/communications',
    name: 'communications',
    slug: 'communications',
    icon: 'PhoneIcon',
    i18n: 'Communications',
    permission: ['communication.email-log.list','communication.phone-log.list']
  },
  {
    url: '/account',
    name: 'account',
    slug: 'account',
    icon: 'CreditCardIcon',
    i18n: 'Accounts',
    permission: 'bank-account.list'
  },
  {
    url: '/billing',
    name: 'billing',
    slug: 'billing',
    icon: 'DollarSignIcon',
    i18n: 'Billing',
    permission: 'billing.list'
  },
  {
    url: '/reports',
    name: 'reports',
    slug: 'reports',
    icon: 'PieChartIcon',
    i18n: 'Reports',
    permission: ['billing.report','billing.report.revenue','contact.report','matter.report','task.report']
  },
  // ['billing.report','billing.report.revenue','contact.report','matter.report','task.report']
  // {
  //   url: '/payment',
  //   name: 'payment',
  //   slug: 'payment',
  //   icon: 'CreditCardIcon',
  //   i18n: 'Cio Payment'
  // },
  // {
  //   url: '/help-center',
  //   name: 'help',
  //   slug: 'help',
  //   icon: 'HelpCircleIcon',
  //   i18n: 'Help center'
  // },
  {
    url: '/settings',
    slug: 'settings',
    name: 'settings',
    icon: 'SettingsIcon',
    i18n: 'Settings',
    permission: 'public',
    // ['Setting.Web.edit','Setting.Personal.edit','Setting.System.edit']
  }
]

